import axios from "axios";

const apiUrl = `${process.env.REACT_APP_API_URL}/api/invitations`;
const token = localStorage.getItem("token");

/// POST
// Fonction pour envoyer une invitation
export const sendInvitation = async (invitation) => {
  try {
    const response = await axios.post(`${apiUrl}/sendInvitation`, invitation, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    return response.data;
  } catch (error) {
    console.error("❌ Erreur lors de l'envoi de l'invitation :", error);
  }
};

/// GET
// Fonction pour valider le token d'invitation /:token
export const validateInvitation = async (token) => {
  try {
    const response = await axios.get(`${apiUrl}/validateInvitation/${token}`);
    return response.data;
  } catch (error) {
    console.error("❌ Erreur lors de la validation de l'invitation :", error);
  }
};

/// POST
// Fonction pour enregistrer un enseignant invité
export const registerTeacher = async (token, password) => {
  try {
    console.log("📌 Envoi de la requête avec token :", token); // 🔥 Debugging

    const response = await axios.post(`${apiUrl}/registerTeacher`, {
      token, // ✅ Assurez-vous que le token est bien envoyé ici
      password,
    });

    return response.data;
  } catch (error) {
    console.error(
      "❌ Erreur lors de l'enregistrement de l'enseignant invité :",
      error
    );
    throw error;
  }
};
